const idtype = {
  CRN: "CRN",
  UAM: "UAM",
};

export default idtype;

export const VISIBLE_PHONE_DIGITS = 2;
export const EDITABLE_TIME_LIMIT_MS = 3 * 60 * 60 * 1000;

export const ORDER_STATUSES = {
  CANCELLATION_REQUESTED: 4,
  CANCELLED: 5,
  SUSPENDED: 6,
};

export const SELECTED_SCRIPT_IDS = {
  UPDATE_ORDER_MODIFICATION_REQUEST: 3,
};

export const UPLOAD_SCRIPT_TYPE = [
  {
    key: 3,
    label: "Update Order Modification Request",
    value: "UPDATE_ORDER_MODIFICATION_REQUEST",
  },
];

export const ADMIN_SUPPORT_MODULE_ID = 2;

export const FILE_UPLOAD_STATUS = {
  CREATED: 1,
  UPLOADED: 2,
  PROCESSED: 3,
};

export const PRODUCT_LIST = [
  { key: 1, label: "Inmobius", value: "INMOBIUS" },
  { key: 2, label: "Meta", value: "META" },
  { key: 3, label: "IL", value: "IL" },
  { key: 4, label: "ILSCHOOLs", value: "ILSCHOOLs" },
  { key: 5, label: "Meta Jr.", value: "META_JR" },
  {
    key: 6,
    label: "Success center/Knowledge Hub",
    value: "SUCCESS_CENTER_OR_KNOWLEDGE_HUB",
  },
  { key: 7, label: "TUITION", value: "TUITION" },
];
export const PRODUCT_TENANT_MAPPING = {
  INMOBIUS: { product_id: 100, tenant_id: 99999 },
  META: { product_id: 200, tenant_id: 2 },
  IL: { product_id: 300, tenant_id: 1 },
  ILSCHOOLs: { product_id: 500, tenant_id: 0 },
  META_JR: { product_id: 600, tenant_id: 2 },
  SUCCESS_CENTER_OR_KNOWLEDGE_HUB: { product_id: 700, tenant_id: 6 },
  TUITION: { product_id: 800, tenant_id: null },
};

export const VERTICALS = [
  { key: 1, label: "Learn", value: "LEARN" },
  { key: 2, label: "SCA", value: "SCA" },
];

export const VERTICAL_IDS = {
  LEARN: "LEARN",
  SCA: "SCA",
};

export const MODIFICATION_ORDERS_COLUMN = [
  { label: "Order Id", field: "orderId" },
  { label: "Amount", field: "amount" },
  { label: "Order Status", field: "orderStatus" },
  { label: "Actions", field: "actions" },
];

export const LEARN_VERTICAL_ID = 1

export const LEARN_TENANT_ID = 1
export const ADMIN_SUPPORT_SOURCE_ID = 3
export const ORDER_MODIFICATION_DECISION = {
  ACCEPT: "ACCEPT",
  REJECT: "REJECT_BY_CUSTOMER_SUPPORT",
}